import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-4a81d768"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = { class: "btn-box" };
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("申请纸质报告");
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("申请发票");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("预览报告");
var _hoisted_7 = { class: "overlay-wrapper" };
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("支付结果查询中...");
import { reactive, ref } from "vue";
import OrderInfo from "../components/orderDetails/orderInfo.vue";
import PatientInfo from "../components/orderDetails/patientInfo.vue";
import OtherIndo from "../components/orderDetails/otherInfo.vue";
import RequestPaper from "../components/requestPaper.vue";
import { useRouter, useRoute } from "vue-router";
import { requestOrderDetails, requestInvoice } from "@/api";
import { Toast } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrderDetails',
    setup: function (__props) {
        var _this = this;
        var router = useRouter();
        var route = useRoute();
        var orderId = route.query.orderId;
        var active = ref(0);
        var payLoadingVisible = ref(false);
        var orderInfo = ref();
        var patientInfo = ref();
        var otherInfo = ref();
        var reportUrl = ref();
        var requestPaperParams = reactive({
            orderId: orderId,
            reportId: "",
            patientId: "",
        });
        var getOrderDrtails = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, data, testUserDetail, patientDetail, sampleBindingDetail, testItemHistoryDetail, patientName, patientGender, patientAge, clinicalDiagnosis, medicationHistory, diseaseStage, familyMedicalHistory, allogeneicTransfusion, organTransplant, stemCellTransplant, infectiousDisease, previousTreatmentRegimen, formulateTreatmentPlan, reportReceivingAddress, reportReceivingEmail, reportReceiver, reportReceiverMobile, samplingTime, samplingSite, primaryTumor, sampleType, sliceForm, hadTest, testTime, testResult;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, requestOrderDetails(orderId)];
                    case 1:
                        res = _d.sent();
                        if (res.code === 200) {
                            data = res.data;
                            testUserDetail = data.testUserDetail, patientDetail = data.patientDetail, sampleBindingDetail = data.sampleBindingDetail, testItemHistoryDetail = data.testItemHistoryDetail;
                            orderInfo.value = {
                                orderStatus: data.orderStatus,
                                skuName: data.skuName,
                                hospitalName: data.hospitalName,
                                doctor: data.departName + "/" + data.doctorName,
                                cardName: testUserDetail.cardName,
                                certificateType: testUserDetail.certificateType,
                                cardNo: testUserDetail.cardNo,
                                createTime: data.createTime,
                                sampleCode: data.sampleBindingDetail.sampleCode,
                                invoiceApply: data.invoiceApply,
                                reportPaperApply: data.reportPaperApply,
                            };
                            patientName = patientDetail.patientName, patientGender = patientDetail.patientGender, patientAge = patientDetail.patientAge, clinicalDiagnosis = patientDetail.clinicalDiagnosis, medicationHistory = patientDetail.medicationHistory, diseaseStage = patientDetail.diseaseStage, familyMedicalHistory = patientDetail.familyMedicalHistory, allogeneicTransfusion = patientDetail.allogeneicTransfusion, organTransplant = patientDetail.organTransplant, stemCellTransplant = patientDetail.stemCellTransplant, infectiousDisease = patientDetail.infectiousDisease, previousTreatmentRegimen = patientDetail.previousTreatmentRegimen, formulateTreatmentPlan = patientDetail.formulateTreatmentPlan, reportReceivingAddress = patientDetail.reportReceivingAddress, reportReceivingEmail = patientDetail.reportReceivingEmail, reportReceiver = patientDetail.reportReceiver, reportReceiverMobile = patientDetail.reportReceiverMobile;
                            patientInfo.value = {
                                orderStatus: data.orderStatus,
                                patientName: patientName,
                                patientGender: patientGender,
                                patientAge: patientAge,
                                clinicalDiagnosis: clinicalDiagnosis,
                                medicationHistory: medicationHistory,
                                diseaseStage: diseaseStage,
                                familyMedicalHistory: familyMedicalHistory,
                                allogeneicTransfusion: allogeneicTransfusion,
                                organTransplant: organTransplant,
                                stemCellTransplant: stemCellTransplant,
                                infectiousDisease: infectiousDisease,
                                previousTreatmentRegimen: previousTreatmentRegimen,
                                formulateTreatmentPlan: formulateTreatmentPlan,
                                reportReceivingAddress: reportReceivingAddress,
                                reportReceivingEmail: reportReceivingEmail,
                                reportReceiver: reportReceiver,
                                reportReceiverMobile: reportReceiverMobile,
                            };
                            samplingTime = sampleBindingDetail.samplingTime, samplingSite = sampleBindingDetail.samplingSite, primaryTumor = sampleBindingDetail.primaryTumor, sampleType = sampleBindingDetail.sampleType, sliceForm = sampleBindingDetail.sliceForm;
                            hadTest = testItemHistoryDetail.hadTest, testTime = testItemHistoryDetail.testTime, testResult = testItemHistoryDetail.testResult;
                            otherInfo.value = {
                                samplingTime: samplingTime,
                                samplingSite: samplingSite,
                                primaryTumor: primaryTumor,
                                sampleType: sampleType,
                                sliceForm: sliceForm,
                                sampleNum: sampleBindingDetail.otherSamples ||
                                    sampleBindingDetail.paraffinCount ||
                                    sampleBindingDetail.surgeryPunctureFreshTissueSite,
                                hadTest: hadTest,
                                testTime: testTime,
                                testResult: testResult,
                                userSign: sampleBindingDetail.userSign || data.userSign,
                            };
                            reportUrl.value = (_a = res.data.testReportDetail) === null || _a === void 0 ? void 0 : _a.reportUrl;
                            requestPaperParams.reportId = (_b = res.data.testReportDetail) === null || _b === void 0 ? void 0 : _b.reportId;
                            requestPaperParams.patientId = (_c = res.data.patientDetail) === null || _c === void 0 ? void 0 : _c.patientId;
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        getOrderDrtails();
        var ruquestInvoiceLoading = ref(false);
        var handleRuquestInvoice = function () {
            ruquestInvoiceLoading.value = true;
            requestInvoice(orderId)
                .finally(function () { return (ruquestInvoiceLoading.value = false); })
                .then(function (res) {
                if (res.code === 200) {
                    Toast("申请发票成功");
                    getOrderDrtails();
                }
                else {
                    Toast(res.message);
                }
            });
        };
        var requsetPaperLoading = ref(false);
        var requestPaperVisible = ref(false);
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_tab = _resolveComponent("van-tab");
            var _component_van_tabs = _resolveComponent("van-tabs");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "详情",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_van_tabs, {
                        active: active.value,
                        "onUpdate:active": _cache[3] || (_cache[3] = function ($event) { return ((active).value = $event); }),
                        color: "#3DABA4",
                        sticky: ""
                    }, {
                        default: _withCtx(function () {
                            var _a;
                            return [
                                _createVNode(_component_van_tab, { title: "订单信息" }, {
                                    default: _withCtx(function () {
                                        var _a, _b, _c, _d;
                                        return [
                                            _createVNode(OrderInfo, { orderInfo: orderInfo.value }, null, 8, ["orderInfo"]),
                                            _createElementVNode("div", _hoisted_3, [
                                                (((_a = orderInfo.value) === null || _a === void 0 ? void 0 : _a.orderStatus) === 6 && !((_b = orderInfo.value) === null || _b === void 0 ? void 0 : _b.reportPaperApply))
                                                    ? (_openBlock(), _createBlock(_component_van_button, {
                                                        key: 0,
                                                        style: _normalizeStyle({ width: '3.28rem' }),
                                                        color: "#3DABA4",
                                                        plain: "",
                                                        onClick: _cache[1] || (_cache[1] = function ($event) { return (requestPaperVisible.value = true); }),
                                                        loading: requsetPaperLoading.value
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_4
                                                        ]; }),
                                                        _: 1
                                                    }, 8, ["style", "loading"]))
                                                    : _createCommentVNode("", true),
                                                (((_c = orderInfo.value) === null || _c === void 0 ? void 0 : _c.orderStatus) === 6 && !((_d = orderInfo.value) === null || _d === void 0 ? void 0 : _d.invoiceApply))
                                                    ? (_openBlock(), _createBlock(_component_van_button, {
                                                        key: 1,
                                                        style: _normalizeStyle({ width: '3.28rem' }),
                                                        color: "#3DABA4",
                                                        plain: "",
                                                        onClick: handleRuquestInvoice,
                                                        loading: ruquestInvoiceLoading.value
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _hoisted_5
                                                        ]; }),
                                                        _: 1
                                                    }, 8, ["style", "loading"]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ];
                                    }),
                                    _: 1
                                }),
                                _createVNode(_component_van_tab, { title: "患者信息" }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(PatientInfo, { patientInfo: patientInfo.value }, null, 8, ["patientInfo"])
                                    ]; }),
                                    _: 1
                                }),
                                _createVNode(_component_van_tab, { title: "其他" }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(OtherIndo, { otherInfo: otherInfo.value }, null, 8, ["otherInfo"])
                                    ]; }),
                                    _: 1
                                }),
                                (((_a = patientInfo.value) === null || _a === void 0 ? void 0 : _a.orderStatus) === 6)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "submit-box",
                                        style: _normalizeStyle({ margin: '0.32rem 0 0.48rem' })
                                    }, [
                                        _createVNode(_component_van_button, {
                                            style: { width: '100%' },
                                            color: "#3DABA4",
                                            plain: "",
                                            block: "",
                                            onClick: _cache[2] || (_cache[2] = function ($event) { return (_unref(router).push("/review-report?reportUrl=" + reportUrl.value)); })
                                        }, {
                                            default: _withCtx(function () { return [
                                                _hoisted_6
                                            ]; }),
                                            _: 1
                                        })
                                    ], 4))
                                    : _createCommentVNode("", true)
                            ];
                        }),
                        _: 1
                    }, 8, ["active"])
                ]),
                _createVNode(_component_van_overlay, {
                    show: payLoadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_8
                                ]; }),
                                _: 1
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"]),
                (requestPaperVisible.value)
                    ? (_openBlock(), _createBlock(RequestPaper, {
                        key: 0,
                        reportReceivingAddress: patientInfo.value.reportReceivingAddress,
                        reportReceivingEmail: patientInfo.value.reportReceivingEmail,
                        orderId: requestPaperParams.orderId,
                        reportId: requestPaperParams.reportId,
                        patientId: requestPaperParams.patientId,
                        onOk: _cache[4] || (_cache[4] =
                            function () {
                                getOrderDrtails();
                                requestPaperVisible.value = false;
                            }),
                        onCancel: _cache[5] || (_cache[5] = function ($event) { return (requestPaperVisible.value = false); })
                    }, null, 8, ["reportReceivingAddress", "reportReceivingEmail", "orderId", "reportId", "patientId"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
